<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人员本地ID转换为云端对应ID</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			把一个已注册人员的本地人员ID转换为FRM云端的对应人员ID，本地ID为局部ID，应用清理数据后失效。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char* __stdcall SKFacePersonLocalID2ServerID(const char* pszPersonLocalID);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">pszPersonLocalID：人员本地ID</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	const char*类型，人员云端ID。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char *pszServerID = SKFacePersonLocalID2ServerID("1111");</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Windows','FRM接口','人员本地ID转换为云端对应ID'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacewindows/frm/transformationID.vue